import type { PlaylistEntry } from './PlaylistController'
import type { PlayerKind } from './SubPlayer'
import { isAsinTrackEntry } from './playbackEntryKind'

/**
 * The content→engine routing decision — the single place playback engine
 * selection lives (HLD §3.4). Audiobooks play on the Audible engine; catalog
 * tracks streamed by asin on the catalog Vinyl engine; everything else (podcasts,
 * video, samples, progressive and lazily resolved sources) on the media Vinyl
 * engine. A future live-stream / DRM engine slots in as a new branch here.
 */
export function selectPlayerKind(entry: PlaylistEntry | null): PlayerKind {
    if (entry?.entity.__typename === 'Audiobook') return 'audible'
    return isCatalogStreamEntry(entry) ? 'vinylCatalog' : 'vinylMedia'
}

function isCatalogStreamEntry(entry: PlaylistEntry | null): boolean {
    if (entry == null || entry.video === true || !isAsinTrackEntry(entry)) return false
    const options = entry.trackLoadOptions
    return typeof options !== 'function' && options.type === 'asin'
}
